var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWindNorth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "48px",
    viewBox: "0 0 48 48",
    width: "48px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#48484a",
    fillRule: "evenodd",
    id: "arrow-down",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0839749,20.2226499 L15.0434343,20.2953753 C14.8973068,20.6162383 15.1291771,21 15.5,21 L21,21 L21,39.5 C21,39.7761424 21.2238576,40 21.5,40 L25.5,40 L25.5898756,39.9919443 C25.8231248,39.9496084 26,39.7454599 26,39.5 L26,21 L31.5,21 C31.8993477,21 32.1375434,20.5549273 31.9160251,20.2226499 L23.9160251,8.2226499 C23.7181141,7.92578337 23.2818859,7.92578337 23.0839749,8.2226499 L15.0839749,20.2226499 Z",
    fill: "#000000",
    fillRule: "nonzero",
    id: "Path",
    transform: "translate(23.500000, 24.000000) scale(1, -1) translate(-23.500000, -24.000000) "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindNorth);
export default __webpack_public_path__ + "static/media/windNorth.43231c2877382cb016168972572cd7c8.svg";
export { ForwardRef as ReactComponent };